/**
 * Function to transform cents to dollars or viceversa
 */
export const formatAmount = (
    conversionType: "cent-to-dollar" | "dollar-to-cent",
    amount: number,
) => {
    return conversionType === "cent-to-dollar"
        ? amount / 100
        : Math.round((Math.abs(amount) / 100) * 10000);
};
